import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
// import useFirebase from "../../../../useFirebase";
import useLangTranslation from "../../../customHooks/languageProvider";
import { getWebFilter } from "../../AxiosRtk/Gallery";

const GalleryFilter = ({
  showModal,
  closeModal,
  setFilterData,
  selectedDeviceId
}) => {
  const { getLangTranslation } = useLangTranslation();
  const [categories, setCategories] = useState();
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

  useEffect(() => {
    if (selectedDeviceId && showModal) {
      getWebFiltersMethod(selectedDeviceId);
    }
  }, [selectedDeviceId, showModal]);

  function getWebFiltersMethod() {
    const obj = {
      deviceId: selectedDeviceId,
      isGalleryFilter: 1
    }
    getWebFilter(obj)
      .then((res) => {
        setCategories(res?.data?.result);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      })
  }

  const handleCheckboxChange = (categoryId) => {
    const updatedSelectedCategoryIds = selectedCategoryIds?.includes(categoryId)
      ? selectedCategoryIds?.filter((id) => id !== categoryId) // Remove the category ID if already selected
      : [...selectedCategoryIds, categoryId]; // Add the category ID if not already selected
    setSelectedCategoryIds(updatedSelectedCategoryIds);
  };

  const handleSave = () => {
    closeModal();
    setFilterData({ selectedCategoryIds });
  };

  // Function to clear all checkboxes
  const handleClearAll = () => {
    setSelectedCategoryIds([]);
  };

  return (
    <>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation("GALLERY_HISTORY_FILTER_KEYWORD", "KEYWORD FILTERS")}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="modal-body">
            {categories?.map((item) => (
              <div
                key={item?.ID}
                className="d-flex align-items-center gap-2 mb-3"
              >
                <h6 className="text-blue-900 mb-0">{item?.url}</h6>
                <input
                  className="form-check-input ms-auto"
                  type="checkbox"
                  value={item?.ID}
                  id={`category_${item?.ID}`}
                  onChange={() => handleCheckboxChange(item?.ID)}
                  checked={selectedCategoryIds?.includes(item?.ID)}
                />
              </div>
            ))}

            <div className="grid gap-3 mt-6">
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                onClick={handleClearAll}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CLEAR_ALL", "Clear all")}
                </span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                type="button"
                onClick={handleSave}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("SAVE", "Save")}
                </span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GalleryFilter;
